import apiClient from './apiClient';
import { ENDPOINTS } from '../constants/api';

/**
 * Request Service
 * Communicates with the backend /api/v1/request controller.
 */

/**
 * Send a new request (public endpoint).
 * @param {{ fullName: string, phone: string, text: string, isRead: boolean, eventDate: string|null, isEventDateClear: boolean, eventIds: number[] }} data
 * @returns {Promise<object>} Response data
 */
export async function createRequest(data) {
  const { data: response } = await apiClient.post(ENDPOINTS.request.send, data);
  return response;
}

/**
 * Fetch all requests with pagination (admin / user authorized).
 * @param {number} page
 * @param {number} size
 * @returns {Promise<object>} Paginated response: { data: [...], pages, elements, ... }
 */
export async function getAllRequests(page = 0, size = 10) {
  const { data: response } = await apiClient.get(ENDPOINTS.request.all, {
    params: { page, size },
  });
  return response; // Returns the full ApiResponse: { data, pages, elements, status, message }
}

/**
 * Toggle read state of a request (admin / user authorized).
 * @param {number|string} id
 * @param {boolean} isRead
 * @returns {Promise<object>} Response data
 */
export async function toggleIsRead(id, isRead) {
  const { data: response } = await apiClient.put(
    ENDPOINTS.request.toggleIsRead(id),
    null, // No body needed for this endpoint
    { params: { isRead } }
  );
  return response;
}
